import { useSelector, useDispatch } from "react-redux"
import { useContext, useCallback } from "react"
import { addMessage as addMessageAction } from "../features/messages/addMessage"
import { viewContext } from "../context/viewContext"

export const useAddMessage = () => {
  const { unique_owner_id } = useContext(viewContext)
  const dispatch = useDispatch()
  const owner = useSelector(state => state.owners[unique_owner_id])

  const status = owner?.actionStatuses?.addMessage?.status
  const loaded = owner?.actionStatuses?.addMessage?.loaded

  const isFetching = status === 'fetching'
  const isLoading = status === 'fetching' && !loaded
  const isSuccess = status === 'success'
  const error = status === 'failed'

  const addMessage = useCallback(async (message) => {
    try {
      const response = await dispatch(addMessageAction(message))
      return response
    } catch (error) {
      throw error
    }
  }, [dispatch])

  return [
    addMessage,
    {
      isFetching,
      isLoading,
      isSuccess,
      error,
    }
  ]
}
